import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="6.8mm"
    height={17.974}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 31499 22029"
    {...props}
  >
    <path
      d="m22110 20457-130 61-735 1511h10254l-735-1511-131-61c-3907-1858-3710-5086-3700-5222l35-439h-191V2920h769v-532h3709V0H244v2388h3708v532h770v11876h-191l36 440c2 34 228 3350-3702 5221l-128 61L0 22029h10256l-737-1511-128-61c-3908-1858-3713-5086-3703-5222l37-439h-191V2920h769v-532h8272v532h768v11876h-189l34 440c5 34 230 3350-3700 5221l-130 61-735 1511h10254l-735-1511-131-61c-3907-1858-3710-5086-3700-5222l35-439h-191V2920h769v-532h8272v532h768v11876h-189l34 440c6 34 231 3350-3699 5221z"
      style={{
        fill: "#231f20",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
